import { formatCurrency } from './currency.utils';

export const ALL = 'ALL';
export const FIVE_STAR = 5;
export const FOUR_STAR = 4;
export const THREE_STAR = 3;

const hotelMatrix = {
  [ALL]: {
    order: 0,
    label: 'AllStar',
  },
  [THREE_STAR]: {
    order: 3,
    label: '3Star',
  },
  [FOUR_STAR]: {
    order: 4,
    label: '4Star',
  },
  [FIVE_STAR]: {
    order: 5,
    label: '5Star',
  },
};

const mapHotel = (hotel, regionIdList) => {
  let isShowOnTop = 0;

  // TODO: Ask if this is correct
  if (hotel.Supplier.toLowerCase() === 'hotelscom') {
    isShowOnTop = 1;
  } else {
    isShowOnTop = 2;
  }

  const hotelResponse = {
    ...hotel,
    HotelImage: hotel.HotelImage.replace('http://', 'https://'),
    RoomRate: 0,
    ProximityDistance: hotel.ProximityDistance == 0 ? 0.1 : hotel.ProximityDistance,
    OrderIndex: isShowOnTop,
    AirportDistance: hotel.AirportDistance == 0 ? 0.1 : hotel.AirportDistance,
    CityCenterDistance: hotel.CityCenterDistance == 0 ? 0.1 : hotel.CityCenterDistance,
    distance: hotel.CityCenterDistance == 0 ? 0.1 : hotel.CityCenterDistance,
    regionIdList,
  };

  if (hotel.PayNowRate > 0) {
    hotelResponse.payNow = {
      price: hotel.PayNowRate,
      isLowest: hotel.PayLaterRate == 0 ? true : hotel.PayNowRate <= hotel.PayLaterRate,
    };

    if (hotel.OutSidePolicyException) {
      const policy = hotel.OutSidePolicyException;

      hotelResponse.payNow.policyKey = policy.PolicyKey;
      hotelResponse.payNow.policyId = policy.PolicyKey;
      hotelResponse.payNow.reasonCode = policy.ReasonCode;
      hotelResponse.payNow.reasonDescription = policy.ReasonDescription;
    }

    if (hotel.IsStrikeOutPriceAvailable) {
      hotelResponse.payNow.isLowest =
        hotel.CorporateRate == 0
          ? true
          : hotel.RateCost < hotel.CorporateRate || hotel.CorporateRate == hotel.RateCost;
    } else {
      hotelResponse.payNow.isLowest =
        hotel.PayLaterRate == 0 ? true : hotel.RateCost <= hotel.PayLaterRate;
    }
  }

  if (hotel.IsSabreExist && (hotel.PayLaterRate > 0 || hotel.CorporateRate > 0)) {
    hotelResponse.payLater = {
      price:
        hotel.IsCorporateRate && hotel.CorporateRate > 0 ? hotel.CorporateRate : hotel.PayLaterRate,
      isLowest:
        hotel.PayNowRate == 0 || hotel.PayLaterRate == 0
          ? true
          : hotel.IsCorporateRate
          ? hotel.CorporateRate < hotel.PayNowRate
          : hotel.PayLaterRate < hotel.PayNowRate,
    };

    if (hotel.OutSidePolicyExceptionPayLater) {
      const policy = hotel.OutSidePolicyExceptionPayLater;

      hotelResponse.payLater.policyKey = policy.PolicyKey;
      hotelResponse.payLater.policyId = policy.PolicyKey;
      hotelResponse.payLater.reasonCode = policy.ReasonCode;
      hotelResponse.payLater.reasonDescription = policy.ReasonDescription;
    }

    if (hotel.IsStrikeOutPriceAvailable) {
      //hotelResponse.payLater.price = hotel.CorporateRate;
      hotelResponse.payLater.isLowest =
        hotel.PayNowRate == 0
          ? true
          : hotel.CorporateRate == 0
          ? true
          : hotel.CorporateRate < hotel.PayNowRate;
    } else {
      //hotelResponse.payLater.price = hotel.PayLaterRate;
      hotelResponse.payLater.isLowest =
        hotel.PayLaterRate == 0 || hotel.PayNowRate == 0
          ? true
          : hotel.PayLaterRate < hotel.PayNowRate;
    }
  }

  return hotelResponse;
};

export const getHotellistData = (list, neiborhood) => {
  let neiborhoodList = {};

  if (neiborhood) {
    neiborhoodList = neiborhood.reduce((acum, value) => {
      if (acum[value.HotelId]) {
        acum[value.HotelId].push(value.RegionId);
      } else {
        acum[value.HotelId] = [value.RegionId];
      }
      return acum;
    }, {});
  }

  return list.map((hotel) => {
    return mapHotel(hotel, neiborhoodList[hotel.HotelId]);
  });
};

export const getFiltersHotel = (list) => {
  if (!list) {
    return {};
  }

  const groupedList = list.reduce((res, item) => {
    const star = item.StarRating;
    const hotelCode = item.HotelCode;
    const price = item.price;

    if (star < 2) {
      return res;
    }

    if (res[star]) {
      if (res[star].lowestPrice > price) {
        res[star].lowestPrice = price;
      }
    } else {
      res[star] = {
        count: 0,
        lowestPrice: price,
        items: {},
        checked: true,
      };
    }

    if (star > 2 && hotelCode) {
      res[star].count++;
      if (res[star].items[hotelCode]) {
        const existent = res[star].items[hotelCode];
        if (existent.price > price) {
          existent.price = price;
        }
        existent.count++;
      } else {
        res[star].items[hotelCode] = {
          name: item.ChainName,
          price: price,
          count: 1,
          checked: true,
        };
      }
    } else if (star === 2) {
      res[star].count++;
    }

    return res;
  }, {});

  return Object.entries(groupedList).reduce((res, [star, starContent]) => {
    const items = Object.entries(starContent.items)
      // eslint-disable-next-line no-unused-vars
      .sort(([key, value], [key1, value1]) => {
        return value.count > value1.count ? -1 : 1;
      })
      .reduce((acum, [key, value], index) => {
        if (index < 3) {
          acum[key] = value;
        } else {
          if (!acum.other) {
            acum.other = {
              name: 'All others',
              price: value.price,
              count: value.count,
              checked: true,
            };
          } else {
            acum.other.price = acum.other.price < value.price ? acum.other.price : value.price;
            acum.other.count = acum.other.count + value.count;
          }
        }

        return acum;
      }, {});

    res[star] = {
      ...starContent,
      items,
    };

    return res;
  }, {});
};

export const convertHotelDataToSegment = (list, currency, currencyCulture) => {
  if (!list) {
    return list;
  }

  const res = list.reduce(
    (acum, current) => {
      if (acum[current.StarRating] && acum[current.StarRating] > current.price) {
        acum[current.StarRating] = current.price;
      }
      if (acum[ALL] > current.price) {
        acum[ALL] = current.price;
      }

      return acum;
    },
    {
      [ALL]: Infinity,
      [THREE_STAR]: Infinity,
      [FOUR_STAR]: Infinity,
      [FIVE_STAR]: Infinity,
    }
  );

  return Object.entries(res)
    .map(([key, value]) => ({
      key: hotelMatrix[key].label,
      value: key,
      label: value === Infinity ? 'None' : formatCurrency(value, currency, currencyCulture),
    }))
    .sort((a, b) => hotelMatrix[a.value].order - hotelMatrix[b.value].order);
};

export const mapNeighbourhoodList = (list) => {
  if (!list) {
    return list;
  }

  return list.reduce((res, h) => {
    res[h.RegionId] = {
      name: h.RegionName,
      price: h.Price,
      checked: true,
    };
    return res;
  }, {});
};

export const getFilterByDetails = (list, neighbourhoodList) => {
  if (!list) {
    return list;
  }

  const filterByDetails = {
    star: getFiltersHotel(list),
  };

  if (neighbourhoodList?.length > 0) {
    filterByDetails.neiborhood = {
      group: {
        items: neighbourhoodList.reduce((res, h) => {
          res[h.RegionId] = {
            name: h.RegionName,
            price: neighbourhoodList[h.RegionId],
            checked: true,
          };
          return res;
        }, {}),
      },
    };
  }

  return filterByDetails;
};
